import { Skeleton, SkeletonProps } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { CSSProperties, ReactNode } from "react";

interface SkeletonWrapperProps {
  id?: string;
  children?: ReactNode;
  variant?: "text" | "rectangular" | "rounded" | "circular";
  condition?: boolean;
  multipleCount?: number;
  props?: SkeletonProps[] | SkeletonProps;
  sx?: SxProps<Theme>;
  skeletonDivSx?: CSSProperties;
  contentDivSx?: CSSProperties;
}

const SkeletonWrapper = ({
  id,
  children,
  variant,
  condition,
  multipleCount = 1,
  props,
  sx = {},
  skeletonDivSx = { display: "flex", flexDirection: "column", width: "100%" },
  contentDivSx = {},
}: SkeletonWrapperProps) => {
  // Ensure multipleCount is a number
  const count = Number(multipleCount) || 1;

  // Use variables to avoid TypeScript strict type inference
  const skeletonStyle = skeletonDivSx;
  const contentStyle = contentDivSx;

  // Normalize props to always be an array
  const propsArray = Array.isArray(props) ? props : props ? [props] : [{}];

  return (
    <>
      {condition ? (
        <div data-testid={`${id}-content`} style={contentStyle}>
          {children}
        </div>
      ) : count > 1 ? (
        <div data-testid={`${id}-skeletons`} style={skeletonStyle}>
          {Array(count)
            .fill(null)
            .map((_, i) => (
              <Skeleton
                sx={sx}
                key={i}
                data-testid={`${id}-${i}`}
                variant={variant}
                animation={"wave"}
                {...(propsArray.length > i ? propsArray[i] : propsArray[0])}
              />
            ))}
        </div>
      ) : (
        <div
          data-testid={`${id}-skeleton`}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            ...skeletonStyle,
          }}>
          <Skeleton sx={sx} data-testid={id} animation={"wave"} {...propsArray[0]} variant={variant} />
        </div>
      )}
    </>
  );
};

export default SkeletonWrapper;
